import * as React from 'react'
import { Form, Input, Tooltip } from 'antd'
import { useDebouncer } from '@halo/hooks/use-debouncer'
import { useState } from 'react'
import { InfoCircleOutlined } from '@ant-design/icons'

interface IFPPIProps {
    property: string
    labelText: string
    tooltipText?: string
    placeholder: string
    disabled?: boolean
    value: string
    onChange: (value: string) => void
}

export const FeedPathPropertyInput = (props: IFPPIProps) => {
    const [debounce] = useDebouncer()
    const { property, labelText, tooltipText, placeholder, disabled, value, onChange } = props
    const [tempValue, setTempValue] = useState<string | undefined>(value)

    return (
        <>
            <Form.Item
                label={
                    tooltipText ? (
                        <div className="feed-path-property-input-label">
                            {labelText}
                            <Tooltip title={tooltipText}>
                                <InfoCircleOutlined />
                            </Tooltip>
                        </div>
                    ) : (
                        labelText
                    )
                }
                htmlFor={`fppi-input-${property}`}
            >
                <Input
                    id={`fppi-input-${property}`}
                    autoComplete="off"
                    size="small"
                    placeholder={placeholder}
                    disabled={disabled}
                    value={tempValue}
                    onChange={(ev) => {
                        const input = ev.target.value
                        setTempValue(input)

                        debounce(() => {
                            onChange(input)
                        })
                    }}
                />
            </Form.Item>
        </>
    )
}
